import React, { Component } from "react";
import SocialLinks from "./SocialLinks";

import "./Header.css";

class Header extends Component {
  render() {
    return (
      <div className="menu">
        <div>
          <b>
            <span className="mickies">Mickie's</span> DAIRY BAR
          </b>
        </div>
        <div>
          <SocialLinks />
        </div>
      </div>
    );
  }
}

export default Header;
